import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { DepartmentSelectors } from '@recruitee/department-data';
import { I18nService } from '@recruitee/i18n';
import type { SelectGroupedOptions } from '@recruitee/user-interface';

import type { DynamicSelectOptionsProvider } from '../dynamic-select-field.types';

@Injectable()
export class DepartmentSelectOptionsFacade implements DynamicSelectOptionsProvider {
  public selectGroupedOptions$: Observable<SelectGroupedOptions[]>;

  constructor(
    private store: Store,
    private i18n: I18nService,
  ) {
    this.selectGroupedOptions$ = this.store.select(DepartmentSelectors.entities()).pipe(
      filterBoolean,
      map(departments => [
        {
          label: this.i18n.translate('app.common.none'),
          value: null,
        },
        ...departments.map(department => ({
          label: department.name,
          value: department.id,
        })),
      ]),
      map(options => [
        {
          title: null,
          options,
        },
      ]),
    );
  }
}
